import { Metric } from "../Model/Metric";
import { MetricRepository } from "../Repository/MetricRepository";

export interface GetMetricUseCase {
  invoke:() => Promise<Metric>;
}

export class GetMetrics implements GetMetricUseCase {
  private repo: MetricRepository;
  constructor(_repo: MetricRepository) {
    this.repo = _repo;
  }

  async invoke(){
     
    const getData = await this.repo.getMetrics();
    return getData;
  }
}